import React from 'react';
import { F, linkedIds, InfoTip } from '../utils.jsx';
import { CURRENT_USER } from '../globals.js';
import { es } from '../labelsEs.js';

export default function AccountsList({
  searchTerm, setSearchTerm,
  filterSolutionId, setFilterSolutionId,
  filterIndustry, setFilterIndustry,
  filterCountry, setFilterCountry,
  filterCPId, setFilterCPId,
  filteredAccounts, accounts,
  selectedAccountIds, setSelectedAccountIds,
  deletingAccounts, bulkDeleteAccounts,
  selectAccount,
  showNewAccount, setShowNewAccount,
  showAccImport, setShowAccImport,
  newAccName, setNewAccName,
  newAccWebsite, setNewAccWebsite,
  creatingAcc, createAccount,
  handleAccCsv, accCsvRows, setAccCsvRows,
  accImporting, importAccounts, accImportResult,
  updateAccDuplicates, setUpdateAccDuplicates,
  setEditingAccount,
  data, outreach, opportunities,
}) {
  return (
    <>
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <h1>Empresas</h1>
          <p>Cada empresa con sus contactos, oportunidades y próximos pasos</p>
        </div>
        {CURRENT_USER?.role === 'admin' && (
          <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
            <button className="action-btn btn-primary" style={{ fontSize: 12 }} onClick={() => { setShowNewAccount(!showNewAccount); setShowAccImport(false); }}>
              {showNewAccount ? 'Cerrar' : 'Nueva empresa'}
            </button>
            <button className="action-btn btn-ghost" style={{ fontSize: 12 }} onClick={() => { setShowAccImport(!showAccImport); setShowNewAccount(false); }}>
              {showAccImport ? 'Cerrar importación' : 'Importar CSV'}
            </button>
          </div>
        )}
      </div>

      <div className="filters-row" style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
        <input className="input-field" style={{ maxWidth: 300 }} placeholder="Buscar empresa…" value={searchTerm}
          onChange={e => { setSearchTerm(e.target.value); selectAccount(''); }} />
        <select
          className="input-field"
          style={{ maxWidth: 220, fontSize: 12, padding: '8px 10px', background: 'var(--globant-card)', border: '1px solid var(--globant-border)', color: filterSolutionId ? 'var(--globant-green)' : 'var(--globant-muted)', borderRadius: 8 }}
          value={filterSolutionId}
          onChange={e => { setFilterSolutionId(e.target.value); selectAccount(''); }}
        >
          <option value="">Todos los servicios</option>
          {(data.solutions || []).map(s => (
            <option key={s.id} value={s.id}>{F(s, 'Name')}</option>
          ))}
        </select>
        <select
          className="input-field"
          style={{ maxWidth: 200, fontSize: 12, padding: '8px 10px', background: 'var(--globant-card)', border: '1px solid var(--globant-border)', color: filterIndustry ? 'var(--globant-info)' : 'var(--globant-muted)', borderRadius: 8 }}
          value={filterIndustry}
          onChange={e => { setFilterIndustry(e.target.value); selectAccount(''); }}
        >
          <option value="">Todas las industrias</option>
          {[...new Set(accounts.map(a => F(a, 'Industry')).filter(Boolean))].sort().map(ind => (
            <option key={ind} value={ind}>{ind}</option>
          ))}
        </select>
        <select
          className="input-field"
          style={{ maxWidth: 180, fontSize: 12, padding: '8px 10px', background: 'var(--globant-card)', border: '1px solid var(--globant-border)', color: filterCountry ? '#f472b6' : 'var(--globant-muted)', borderRadius: 8 }}
          value={filterCountry}
          onChange={e => { setFilterCountry(e.target.value); selectAccount(''); }}
        >
          <option value="">Todos los países</option>
          {[...new Set(accounts.map(a => F(a, 'Country')).filter(Boolean))].sort().map(c => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>
        {(data.users || []).length > 0 && (
          <select
            className="input-field"
            style={{ maxWidth: 180, fontSize: 12, padding: '8px 10px', background: 'var(--globant-card)', border: '1px solid var(--globant-border)', color: filterCPId ? '#6B5CA5' : 'var(--globant-muted)', borderRadius: 8 }}
            value={filterCPId}
            onChange={e => { setFilterCPId(e.target.value); selectAccount(''); }}
          >
            <option value="">Todos los responsables</option>
            {(data.users || []).filter(u => F(u, 'Name')).sort((a,b) => (F(a,'Name')||'').localeCompare(F(b,'Name')||'')).map(u => (
              <option key={u.id} value={u.id}>{F(u, 'Name')}</option>
            ))}
          </select>
        )}
        {(filterSolutionId || filterIndustry || filterCountry || filterCPId) && (
          <span
            style={{ fontSize: 11, color: 'var(--globant-green)', fontWeight: 600, cursor: 'pointer', padding: '4px 8px', background: 'rgba(91,191,181,0.1)', borderRadius: 5 }}
            onClick={() => { setFilterSolutionId(''); setFilterIndustry(''); setFilterCountry(''); setFilterCPId(''); }}
            title="Quitar filtros"
          >
            {filteredAccounts.length} {filteredAccounts.length !== 1 ? 'resultados' : 'resultado'} · quitar filtros
          </span>
        )}
      </div>

      {showNewAccount && (
        <div className="card" style={{ borderLeft: '3px solid var(--globant-green)' }}>
          <div className="card-header"><h3>Nueva empresa</h3></div>
          <div style={{ display: 'flex', gap: 10, alignItems: 'flex-end', flexWrap: 'wrap' }}>
            <div style={{ flex: 2, minWidth: 200 }}>
              <label style={{ display: 'block', fontSize: 11, color: 'var(--globant-muted)', marginBottom: 4, fontWeight: 600 }}>NOMBRE DE LA EMPRESA *<InfoTip text="El nombre de la empresa tal como querés verlo en toda la app." /></label>
              <input className="input-field" style={{ width: '100%', fontSize: 12 }}
                placeholder="ej. Andes Logística" value={newAccName} onChange={e => setNewAccName(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && createAccount()} />
            </div>
            <div style={{ flex: 2, minWidth: 200 }}>
              <label style={{ display: 'block', fontSize: 11, color: 'var(--globant-muted)', marginBottom: 4, fontWeight: 600 }}>WEB<InfoTip text="La web de la empresa. La IA la usa para buscar noticias y contexto para los mensajes." /></label>
              <input className="input-field" style={{ width: '100%', fontSize: 12 }}
                placeholder="ej. https://empresa.com" value={newAccWebsite} onChange={e => setNewAccWebsite(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && createAccount()} />
            </div>
            <button className="action-btn btn-primary" style={{ fontSize: 12, padding: '8px 20px' }}
              onClick={createAccount} disabled={!newAccName.trim() || creatingAcc}>
              {creatingAcc ? 'Creando…' : 'Crear empresa'}
            </button>
          </div>
        </div>
      )}

      {showAccImport && (
        <div className="card" style={{ borderLeft: '3px solid var(--globant-info)' }}>
          <div className="card-header"><h3>Importar empresas desde CSV</h3></div>
          <p style={{ fontSize: 12, color: 'var(--globant-muted)', marginBottom: 12, lineHeight: 1.5 }}>
            Subí un CSV con estas columnas: <strong>Account Name</strong> (obligatoria), <strong>Website</strong>, <strong>Country</strong>, <strong>Industry</strong> e <strong>Inside Sales Status</strong> (opcionales). Las repetidas se detectan solas.
          </p>
          <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 12 }}>
            <input type="file" accept=".csv" onChange={handleAccCsv} onClick={e => e.target.value = ''} style={{ fontSize: 12 }} />
            <button className="action-btn btn-ghost" style={{ fontSize: 11 }}
              onClick={() => {
                const csv = 'Account Name,Website,Country,Industry,Company Size,Inside Sales Status\nExample Corp,https://example.com,Spain,SaaS / Software,11 - 50,Active\nAcme Inc,https://acme.io,Mexico,Fintech,1 - 10,';
                const blob = new Blob([csv], { type: 'text/csv' });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a'); a.href = url; a.download = 'accounts_template.csv'; a.click();
              }}>Descargar plantilla</button>
          </div>
          {accCsvRows.length > 0 && (
            <div>
              <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 8, color: 'var(--globant-text)' }}>
                Vista previa: <span style={{ color: 'var(--globant-green)' }}>{accCsvRows.filter(r => r.selected && !r.isDuplicate).length} nuevas</span> · <span style={{ color: '#B4362C' }}>{accCsvRows.filter(r => r.isDuplicate).length} repetidas</span>{accCsvRows.filter(r => r.isFuzzy).length > 0 && <> · <span style={{ color: '#9A6212' }}>{accCsvRows.filter(r => r.isFuzzy).length} posiblemente repetidas</span></>} · {accCsvRows.length} en total
              </div>
              {accCsvRows.some(r => r.isDuplicate) && (
                <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: 'var(--globant-muted)', marginBottom: 10, cursor: 'pointer' }}>
                  <input type="checkbox" checked={updateAccDuplicates} onChange={e => setUpdateAccDuplicates(e.target.checked)} />
                  Actualizar las repetidas (solo completa campos vacíos, no pisa datos)
                </label>
              )}
              <div style={{ maxHeight: 200, overflowY: 'auto', marginBottom: 12 }}>
                <table className="data-table">
                  <thead><tr><th style={{ width: 30 }}></th><th>Nombre</th><th>País</th><th>Industria</th><th>Web</th><th>Estado</th></tr></thead>
                  <tbody>
                    {accCsvRows.map((r, i) => (
                      <tr key={i} style={{ background: r.isFuzzy ? 'rgba(251,191,36,0.04)' : 'transparent' }}>
                        <td><input type="checkbox"
                          checked={r.isDuplicate ? updateAccDuplicates : r.selected}
                          disabled={r.isDuplicate}
                          onChange={e => { const u = [...accCsvRows]; u[i].selected = e.target.checked; setAccCsvRows(u); }} /></td>
                        <td style={{ fontSize: 12 }}>{r.name}</td>
                        <td style={{ fontSize: 11, color: 'var(--globant-muted)' }}>{r.country || '—'}</td>
                        <td style={{ fontSize: 11, color: 'var(--globant-muted)' }}>{r.industry || '—'}</td>
                        <td style={{ fontSize: 11, color: 'var(--globant-muted)' }}>{r.website || '—'}</td>
                        <td>
                          {r.isDuplicate
                            ? <span className="badge" style={{ background: updateAccDuplicates ? 'rgba(251,191,36,0.15)' : 'rgba(239,68,68,0.15)', color: updateAccDuplicates ? '#9A6212' : '#B4362C', fontSize: 9 }}>
                                {updateAccDuplicates ? 'Se actualiza' : r.duplicateReason}
                              </span>
                            : r.isFuzzy
                            ? <span className="badge" style={{ background: 'rgba(251,191,36,0.15)', color: '#9A6212', fontSize: 9 }} title={r.fuzzyReason}>{r.fuzzyReason}</span>
                            : <span className="badge badge-green" style={{ fontSize: 9 }}>Nueva</span>}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <button className="action-btn btn-primary" style={{ fontSize: 12 }}
                onClick={importAccounts} disabled={accImporting || (accCsvRows.filter(r => r.selected && !r.isDuplicate).length === 0 && !(updateAccDuplicates && accCsvRows.some(r => r.isDuplicate)))}>
                {accImporting ? 'Importando…' : `Importar ${accCsvRows.filter(r => r.selected && !r.isDuplicate).length} nuevas${updateAccDuplicates && accCsvRows.some(r => r.isDuplicate) ? ` y actualizar ${accCsvRows.filter(r => r.isDuplicate).length}` : ''}`}
              </button>
              {accImportResult && (
                <span style={{ marginLeft: 12, fontSize: 12, color: 'var(--globant-green)' }}>
                  {accImportResult.created} creadas{accImportResult.updated > 0 ? ` · ${accImportResult.updated} actualizadas` : ''}{accImportResult.failed ? ` · ${accImportResult.failed} con error` : ''}
                </span>
              )}
            </div>
          )}
        </div>
      )}

      <div className="card">
        <div className="card-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <h3>Elegí una empresa</h3>
          {selectedAccountIds.size > 0 && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 12, color: 'var(--globant-muted)' }}>{selectedAccountIds.size} elegidas</span>
              <button
                className="action-btn"
                style={{ fontSize: 11, padding: '4px 10px', background: 'rgba(239,68,68,0.12)', color: '#B4362C', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 6 }}
                onClick={bulkDeleteAccounts}
                disabled={deletingAccounts}
              >
                {deletingAccounts ? 'Borrando…' : 'Borrar elegidas'}
              </button>
              <button className="action-btn btn-ghost" style={{ fontSize: 11 }} onClick={() => setSelectedAccountIds(new Set())}>Quitar selección</button>
            </div>
          )}
        </div>
        <div style={{ overflowX: 'auto' }}>
          <table className="data-table">
            <thead><tr>
              <th style={{ width: 32 }}>
                <input type="checkbox"
                  checked={filteredAccounts.length > 0 && filteredAccounts.every(a => selectedAccountIds.has(a.id))}
                  onChange={e => {
                    if (e.target.checked) setSelectedAccountIds(new Set(filteredAccounts.map(a => a.id)));
                    else setSelectedAccountIds(new Set());
                  }}
                />
              </th>
              <th>Empresa</th><th style={{ textAlign: 'center' }}>Contactos</th><th style={{ textAlign: 'center' }}>Interacciones</th><th style={{ textAlign: 'center' }}>Oportunidades</th><th>Estado</th><th></th>
            </tr></thead>
            <tbody>
              {filteredAccounts.map(a => {
                const stCount = linkedIds(a, 'Stakeholders').length;
                const oCount = outreach.filter(o => linkedIds(o, 'Account').includes(a.id)).length;
                const oppCount = opportunities.filter(o => linkedIds(o, 'Account').includes(a.id)).length;
                const isChecked = selectedAccountIds.has(a.id);
                return (
                  <tr key={a.id} onClick={() => { if (selectedAccountIds.size > 0) { const s = new Set(selectedAccountIds); isChecked ? s.delete(a.id) : s.add(a.id); setSelectedAccountIds(s); } else { selectAccount(a.id); setSearchTerm(''); } }} style={{ cursor: 'pointer', background: isChecked ? 'rgba(239,68,68,0.05)' : undefined }}>
                    <td onClick={e => e.stopPropagation()}>
                      <input type="checkbox" checked={isChecked} onChange={e => { const s = new Set(selectedAccountIds); e.target.checked ? s.add(a.id) : s.delete(a.id); setSelectedAccountIds(s); }} />
                    </td>
                    <td style={{ fontWeight: 600 }}>{F(a, 'Account Name')}</td>
                    <td style={{ textAlign: 'center' }}>{stCount}</td>
                    <td style={{ textAlign: 'center' }}>{oCount > 0 ? <span style={{ color: 'var(--globant-green)', fontWeight: 700 }}>{oCount}</span> : '—'}</td>
                    <td style={{ textAlign: 'center' }}>{oppCount > 0 ? <span className="badge badge-blue">{oppCount}</span> : '—'}</td>
                    <td>{F(a, 'Inside Sales Status') ? <span className="badge badge-accent">{es(F(a, 'Inside Sales Status'))}</span> : '—'}</td>
                    <td style={{ textAlign: 'right' }}>
                      <button className="action-btn btn-ghost" style={{ fontSize: 10, padding: '2px 7px' }} onClick={e => { e.stopPropagation(); setEditingAccount(a); }}>✏️</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
